export const isRequired = fieldName => `${fieldName} is required.`;

export const isValidEmail = fieldName => `${fieldName} is not valid.`;

export const minLength = length => {
	return fieldName => `${fieldName} must be at least ${length} characters.`;
};

export const notValidField = fieldName => `${fieldName} is not valid.`;